var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseCardContainer',{attrs:{"title":"Nouvelle proposition","noFooter":""}},[_c('PropositionForm',{attrs:{"id":"form","prospect":_vm.prospect,"offre":_vm.refObject.offre,"typeRemise":_vm.refObject.typeRemise,"relation":_vm.relation},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }